import React from 'react';

import { ResellerLogoArt } from '@/reseller/sew/logo/reseller-logo-art';
import { RESELLER_LOGO_SVG } from '@/reseller/sew/logo/reseller-logo.const';
import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ResellerLogo: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      {...RESELLER_LOGO_SVG}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ResellerLogoArt />
    </BaseIcon>
  );
};

ResellerLogo.displayName = 'ResellerLogo';
